import { Injectable } from '@angular/core';
import { PurchaseRequestStatus } from '../enums';
import { TimePerStageItem } from '../interfaces/time-per-stage-item';
import { TimePerStageTooltipData } from '../interfaces/time-per-stage-tooltip-data';
import { TimePerStageMetrics } from '../interfaces/time-per-stage-metrics';

@Injectable({
  providedIn: 'root'
})
export class PurchaseRequestTimePerStageService {
  private readonly stageConfig: {
    status: PurchaseRequestStatus;
    label: string;
    color: string;
  }[] = [
    {
      status: PurchaseRequestStatus.PENDING,
      label: 'Pendente',
      color: 'var(--color-info-default)'
    },
    {
      status: PurchaseRequestStatus.ACCEPTED,
      label: 'Aceita',
      color: 'var(--color-success-default)'
    },
    {
      status: PurchaseRequestStatus.IN_QUOTATION,
      label: 'Em cotação',
      color: 'var(--color-warning-default)'
    },
    {
      status: PurchaseRequestStatus.AWAITING_FOR_APPROVAL,
      label: 'Aguardando aprovação',
      color: 'var(--color-info-default)'
    },
    {
      status: PurchaseRequestStatus.PENDING_INTEGRATION,
      label: 'Pendente de integração',
      color: 'var(--color-error-default)'
    },
    {
      status: PurchaseRequestStatus.QUOTED,
      label: 'Concluído',
      color: 'var(--color-success-default)'
    },
    {
      status: PurchaseRequestStatus.URGENT,
      label: 'Urgente',
      color: 'var(--color-error-default)'
    }
  ];

  /**
   * Etapas na ordem do fluxo. A etapa do status atual vai para o fim e recebe `current`:
   * a ordem fixa não basta, porque a solicitação pode voltar a uma etapa anterior
   * (ex.: passou por "Não completada" e voltou para aprovação).
   */
  getItems(
    timePerStage?: TimePerStageMetrics,
    currentStatus?: PurchaseRequestStatus
  ): TimePerStageItem[] {
    if (!timePerStage) {
      return [];
    }

    const items = this.stageConfig
      .filter(entry => timePerStage[entry.status] !== undefined)
      .map(entry => ({
        label: entry.label,
        time: timePerStage[entry.status]!,
        color: entry.color,
        current: entry.status === currentStatus
      }));

    const currentIndex = items.findIndex(item => item.current);
    if (currentIndex >= 0) {
      items.push(...items.splice(currentIndex, 1));
    }

    return items;
  }

  getTotalTime(
    timePerStage?: TimePerStageMetrics
  ): number | null {
    const items = this.getItems(timePerStage);

    if (items.length === 0) {
      return null;
    }

    return items.reduce((acc, item) => acc + item.time, 0);
  }

  getTooltipData(
    timePerStage?: TimePerStageMetrics,
    currentStatus?: PurchaseRequestStatus
  ): TimePerStageTooltipData {
    return {
      items: this.getItems(timePerStage, currentStatus),
      totalTime: this.getTotalTime(timePerStage)
    };
  }
}
